<p-card>
  <div class="row">
    <div class="col-12">
      <h1 class="mb-3">Activos</h1>
      <p class="mb-3 text-color-secondary">
        Aquí podrás ver el inventario actual, los montos, y el estado de arrendamiento de cada activo, utiliza los filtros para encontrar fácilmente la información que necesitas.
      </p>
    </div>
    <p-toast></p-toast>
  </div>
  <div class="row">
    <div class="col-12">
      <app-main-table
        [apiService]="apiActiveService"
        [columns]="columns"
        [pluralEntityName]="'activos'"
        [additionalMainActions]="additionalMainActions"
        (onMainAction)="mainActions($event)"
        [actions]="actions"
        (onAction)="actionMethods($event)"
      ></app-main-table>
    </div>
  </div>
</p-card>

<!--Form to create or update a active-->
<p-dialog [(visible)]="createEntity" [style]="{ width: '750px' }" [header]="action === 'CREATE' ? 'Nuevo activo' : 'Actualizar activo'" [modal]="true" styleClass="p-fluid">
  <ng-template pTemplate="content">
    <app-active-form></app-active-form>
  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
    <button pButton pRipple label="Guardar" icon="pi pi-check" class="p-button-text" (click)="saveForm()" [disabled]="!activeService.entity.valid"></button>
  </ng-template>
</p-dialog>
<!--End of form to create or update a active-->
